module.exports = __webpack_public_path__ + "static/media/progger6.151f7df0.png";